import { useEffect } from "react";
import { Container, Row, Button, Col} from "react-bootstrap";
import DuckNav from "../common/DuckNav";
import DuckRouter from "../common/DuckRouter";
import DrawerNav from "../common/DrawerNav";
import MobileResourceToggle from "../common/MobileResourceToggle";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import AlertDismissible from "../common/AlertDismissible";
import OrderDock from "../common/OrderDock";
import ScrollToTop from "../common/ScrollToTop";
import { addFontAwesomeIcons } from "./App.utils";
import { isIE, isLegacyEdge } from "react-device-detect";
import BrowserSupport, { unsupportedBrowser } from "./BrowserSupport";
import useIsAuthorized from "../hooks/useIsAuthorized";
import Loading from "../common/Loading";
import ConfirmEmail from "../home/ConfirmEmail";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFeather,
  faSignOutAlt,
  faSpinner,
  faTrashAlt,
  faCopy,
  faEye,
  faEdit,
  faPlus,
  faCheckCircle,
  faFileAlt,
  faFilePdf,
  faFileWord,
  faFilePowerpoint,
  faFileExcel,
  faFileCsv,
  faBars,
  faTimes,
  faPrint,
  faKeyboard,
  faDirections,
  faCaretDown,
  faCaretUp,
  faSave,
  faMinus,
  faLeftLong,
  faExpand,
  faFlag,
} from "@fortawesome/free-solid-svg-icons";
const iconList = [
  faFeather,
  faSignOutAlt,
  faSpinner,
  faTrashAlt,
  faCopy,
  faEdit,
  faEye,
  faPlus,
  faCheckCircle,
  faFileAlt,
  faFilePdf,
  faFileWord,
  faFilePowerpoint,
  faFileExcel,
  faFileCsv,
  faBars,
  faTimes,
  faPrint,
  faKeyboard,
  faDirections,
  faCaretDown,
  faCaretUp,
  faSave,
  faMinus,
  faLeftLong,
  faExpand,
  faFlag,
];
addFontAwesomeIcons(iconList, library);

export const AuthorizedDrawerNav = ({
  isAuthorized,
}: {
  isAuthorized: boolean;
}) => {
  return isAuthorized ? <DrawerNav /> : null;
};
export const RenderLoading = ({ loading }: { loading: boolean }) =>
  loading ? (
    <div className="mb-3">
      <Loading size="2x" inline={true} />
    </div>
  ) : null;
export const RenderErrorMessage = ({
  errorMessage,
}: {
  errorMessage: string;
}) =>
  errorMessage ? (
    <Row>
      <Col>
        <AlertDismissible variant="warning">{errorMessage}</AlertDismissible>
      </Col>
    </Row>
  ) : null;
export const RenderClaimsError = ({
  claimsError,
  children,
}: {
  claimsError: boolean | undefined;
  children: any;
}) =>
  claimsError ? (
    <Row>
      <Col>
        <AlertDismissible variant="danger">{children}</AlertDismissible>
      </Col>
    </Row>
  ) : null;
export const Render = ({
  isAuthorized,
  loading,
  login,
}: {
  isAuthorized: boolean;
  loading: boolean;
  login: Function;
}) =>
  !loading ? (
    <>
      {isAuthorized && <OrderDock />}
      <ScrollToTop />
      <DuckRouter />
    </>
  ) : null;

const App = () => {
  const {
    isAuthorized,
    loading,
    isAuthenticated,
    login,
    logout,
    user,
    claimsError,
  } = useIsAuthorized();
  const location = useLocation();
  useEffect(() => {
      ReactGA.set({ page: location.pathname + location.search });
      ReactGA.pageview(location.pathname + location.search);
  }, [location]);
  const { result: unsupported } = unsupportedBrowser({ isIE, isLegacyEdge });
  if (unsupported) {
    return <BrowserSupport isIE={isIE} isLegacyEdge={isLegacyEdge} />;
  }
  return (
    <>
      <DuckNav
        login={login}
        logout={logout}
        user={user}
        isAuthenticated={isAuthenticated}
      />
      <Row className="g-0">
        <AuthorizedDrawerNav isAuthorized={isAuthorized} />
        <Col className="min-vh-100">
          <Container className="my-5">
            <ConfirmEmail />
            <RenderLoading loading={loading} />
            <RenderClaimsError claimsError={claimsError}>
              Our system is down. Please contact support, or{" "}
              <Button
                variant="link"
                className="p-0 align-baseline"
                onClick={() => window.location.reload()}
              >
                reload the page to try again
              </Button>
              .
            </RenderClaimsError>
            <Render
              isAuthorized={isAuthorized}
              loading={loading}
              login={login}
            />
          </Container>
        </Col>
      </Row>
      <MobileResourceToggle />
    </>
  );
};

export default App;
